document.addEventListener("alpine:init", () => {
    Alpine.data("subNav", () => ({
        currentLink: null,
        isFixed: false,
        isMobile: true,
        positionTop: 0,
        lastScrollTop: 0,
        menuOpen: false,
        navMenu: null,
        title: null,
        button: null,
        vlinks: null,
        hlinks: null,
        ctaButton: null,
        breaks: [],
        currentID: null,
        sections: null,
        nav: null,
        navHeight: 0,
        navBar: null,
        init() {
            this.positionTop = pegasus.getElemOffset(this.$el);

            const navLinks = this.$refs.navLinks.querySelectorAll("li");

            this.currentLink = window.location.href;

            this.navMenu = this.$refs.navContainer;
            this.button = this.$refs.navMenuButton;
            this.vlinks = this.$refs.navLinks;
            this.hlinks = this.$refs.hiddenLinks;
            this.title = this.$refs.title;
            this.ctaButton = this.$refs.ctaButton;
            this.sections = document.querySelectorAll(".Pegasus__Container");
            this.nav = document.querySelector("#page-nav-container");
            this.navHeight = this.nav.clientHeight;
            this.navBar = this.$el.querySelector(".Sub__Nav__bar");

            pegasus.onResizeFinished(() => {
                setTimeout(() => {
                    this.navHeight = this.nav.clientHeight;

                    if (this.navHeight > this.navMenu.clientHeight) {
                        this.$refs.spacer.style.height = this.navHeight + "px";
                        this.navBar.style.height = this.navHeight + "px";
                    } else {
                        this.$refs.spacer.style.height =
                            this.navMenu.clientHeight + "px";
                        this.navBar.style.removeProperty("height");
                    }
                }, 300);
            }, true);

            this.checkPosition(true);
        },
        fix() {
            if (this.isFixed) {
                if (window.scrollY <= this.positionTop.top + this.navHeight) {
                    this.isFixed = false;
                }
            } else {
                if (window.scrollY >= this.positionTop.top + this.navHeight) {
                    this.isFixed = true;
                }
            }

            this.checkPosition();
        },

        checkPosition(onLoad = false) {
            const contentRows = document.querySelectorAll(
                ".Pegasus__Container"
            );
            const windowOffset = window.outerHeight / 4;

            contentRows.forEach((row) => {
                if (
                    typeof row.id === "undefined" ||
                    row.id === null ||
                    row.id === ""
                ) {
                    return false;
                }
                const rowTop = pegasus.getElemOffset(row).top,
                    rowBottom = pegasus.getElemOffset(row).bottom;

                let st = window.scrollY;

                if (onLoad) {
                    if (
                        window.scrollY + windowOffset >= rowTop &&
                        window.scrollY + windowOffset <= rowBottom
                    ) {
                        this.currentLink = window.location.href + "#" + row.id;
                    }
                }

                if (st >= this.lastScrollTop) {
                    //Scroll Down
                    if (
                        window.scrollY + windowOffset >= rowTop &&
                        window.scrollY + windowOffset <= rowBottom
                    ) {
                        this.currentLink = window.location.href + "#" + row.id;
                    }
                } else {
                    //Scroll Up
                    if (
                        window.scrollY - windowOffset <= rowBottom &&
                        window.scrollY - windowOffset >= rowTop
                    ) {
                        this.currentLink = window.location.href + "#" + row.id;
                    }
                }

                this.lastScrollTop = st;
            });

            if (window.scrollY <= this.positionTop.top) {
                const allLinks = this.$refs.fixedNav.querySelectorAll("li>a");

                this.currentLink = window.location.href;
            }
        },
    }));
});
